import { forEach, trimString, cancelEvent } from './utils'

export default function formAutoTrim(formElement) {
  formElement.addEventListener('submit', onSubmit)
  forEachTextInput(setupInputElement)

  function forEachTextInput(callback) {
    forEach(formElement.querySelectorAll('input'), function (inputElement) {
      switch (inputElement.getAttribute('type')) {
        case '':
        case 'text':
        case 'email':
        case 'password':
          callback(inputElement)
          break
      }
    })
  }

  function setupInputElement(inputElement) {
    inputElement.addEventListener('focusout', onChange)
    inputElement.addEventListener('change', onChange)

    inputElement.addEventListener('keypress', onKeyPress)

    function onKeyPress(event) {
      if (event.keyCode === 32 && !trimString(inputElement.value)) {
        return cancelEvent(event)
      }
      return undefined
    }

    function onChange() {
      trimInputValue(inputElement)
    }
  }

  function onSubmit(event) {
    forEachTextInput(trimInputValue)

    if (typeof formElement.checkValidity === 'function' && !formElement.checkValidity()) {
      return cancelEvent(event)
    }

    return undefined
  }
}

function trimInputValue(inputElement) {
  const value = inputElement.value
  const newValue = trimString(value)
  if (value !== newValue) {
    inputElement.value = newValue
  }
}
